import axiosClient from "./axiosClient";

const SubscriberApi = {
  register: (subscriber) => {
    return axiosClient.post("/subscriber", subscriber);
  },
};

export default SubscriberApi;
